import HvacOutlined from '@mui/icons-material/HvacOutlined'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import useUser from '../../../../contexts/hooks/useUser'
import { trpc } from '../../../../modules/trpc'
import { HvacContext } from '../../../devices/hvac/HvacContext'
import OverViewCard from '../OverviewCard'

const HvacStateCard = () => {
	const { hvacs } = useContext(HvacContext)
	const history = useHistory()

	const { user } = useUser()
	const { t } = useTranslation('pages_hvac')

	const { data: userSettings } = trpc.user.userSettings.get.useQuery(undefined, {
		enabled: !!user?.id,
	})

	if (!hvacs) return null

	const ThermoIcon: React.FC<{ mode: string }> = ({ mode }) => {
		const src = userSettings?.smartHeatingActive
			? 'assets/thermo/thermoAuto.svg'
			: mode === 'HEAT'
				? 'assets/thermo/thermoHeat.png'
				: mode === 'COOL'
					? 'assets/thermo/thermoCool.png'
					: 'assets/thermo/thermoGoal.png'

		return (
			<img
				src={src}
				alt={t('heatingControls.altThermoStatStatusIcon')}
				style={{ width: '1.2em', height: '1.2em' }}
			/>
		)
	}

	return (
		<OverViewCard
			headerText={t('frontPage.headerText')}
			icon={<HvacOutlined />}
			iconType='mui'
			className='hvac-state-card'
			linkTarget={'devices'}
		>
			<div className='card-content'>
				<div className='hvac-cards-container rounded-xl bg-background-200-light dark:bg-brand-secondary-200-dark'>
					{hvacs?.data.map(hvac => (
						<div
							key={hvac.id}
							className='hvac-card border items-center border-brand-primary-100-light dark:border-brand-primary-100-dark bg-white dark:bg-background-200-dark'
							onClick={() => {
								history.push(`/hvac/${hvac.id}`)
							}}
						>
							<div className='hvac-card-title text-text-grey-200 dark:text-text-grey-100'>
								{hvac.information.displayName}
							</div>
							<div className='hvac-temp'>
								{hvac.mode === 'OFF' && (
									<div className='hvac-status text-text-dark dark:text-white'>
										{t('frontPage.offStatus')}
									</div>
								)}

								<div className='temp text-text-dark dark:text-white flex items-center gap-2'>
									<ThermoIcon mode={hvac.mode} />
									{hvac.currentTemperature !== null
										? `${hvac.currentTemperature}°C`
										: t('frontPage.noTemperatureSet')}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</OverViewCard>
	)
}

export default HvacStateCard
